module.exports = __webpack_public_path__ + "static/media/polymedia-peter-van-der-meer-black.b31f4238.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/polymedia-peter-van-der-meer-black.png
// module id = 5
// module chunks = 0